import * as React from 'react';
import type { SVGProps } from 'react';
const SvgScript = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path d="M8.25 3.983a.75.75 0 0 1 .75-.75h4.333a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75M7.667 15.65a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75m-3.5-5.833a.75.75 0 0 1 .75-.75h7.833a.75.75 0 0 1 0 1.5H4.917a.75.75 0 0 1-.75-.75m1.75-5.9a1.167 1.167 0 1 1-2.334 0 1.167 1.167 0 0 1 2.334 0m12.25 6a1.167 1.167 0 1 1-2.334 0 1.167 1.167 0 0 1 2.334 0m-12.834 5.75a1.167 1.167 0 1 1-2.333 0 1.167 1.167 0 0 1 2.333 0" />
  </svg>
);
export default SvgScript;
